module.exports = __webpack_public_path__ + "static/img/newCode2.329acf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/newCode2.png
// module id = QXCG
// module chunks = 1